module.exports = __webpack_public_path__ + "assets/img/4.9663ff4c.png";